module.exports = __webpack_public_path__ + "static/img/model-like5.d530ee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/model-like5.png
// module id = gqGX
// module chunks = 36